import { Controller } from "@hotwired/stimulus"

export default class SendEboostController extends Controller<HTMLDivElement> {
  declare readonly frameTarget: HTMLElement
  declare readonly headerTarget: HTMLElement

  static targets = ["frame", "header"]

  private boundHandleModalShow!: (event: Event) => void
  private boundHandleModalHidden!: () => void

  connect(): void {
    this.boundHandleModalShow = this.handleModalShow.bind(this)
    this.boundHandleModalHidden = this.handleModalHidden.bind(this)
    // The controller is attached directly to the modal element, so use this.element
    this.element.addEventListener("show.bs.modal", this.boundHandleModalShow)
    this.element.addEventListener("hidden.bs.modal", this.boundHandleModalHidden)
  }

  disconnect(): void {
    this.element.removeEventListener("show.bs.modal", this.boundHandleModalShow)
    this.element.removeEventListener("hidden.bs.modal", this.boundHandleModalHidden)
  }

  private handleModalShow(event: Event): void {
    const modalEvent = event as MouseEvent
    const button = modalEvent.relatedTarget

    if (button instanceof HTMLElement) {
      const src = button.dataset.modalSrc
      if (src) {
        this.frameTarget.innerHTML = ""
        this.frameTarget.setAttribute("src", src)
      }
    }
  }

  private handleModalHidden(): void {
    this.frameTarget.innerHTML = ""
    this.headerTarget.innerHTML = ""
  }
}
